import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-w-0" }
const _hoisted_2 = {
  key: 0,
  class: "py-4 text-sm text-gray-500",
  role: "status"
}
const _hoisted_3 = {
  key: 1,
  class: "rounded-lg bg-gray-50 p-4 text-sm text-gray-600",
  role: "status"
}
const _hoisted_4 = {
  key: 2,
  class: "p-1"
}
const _hoisted_5 = { class: "grid grid-cols-2 gap-3 sm:grid-cols-3" }
const _hoisted_6 = ["aria-label", "aria-pressed", "disabled", "onClick"]
const _hoisted_7 = { class: "relative flex h-32 items-center justify-center bg-gray-50 sm:h-40" }
const _hoisted_8 = ["src", "alt", "onError"]
const _hoisted_9 = {
  key: 1,
  class: "px-2 text-center text-xs text-gray-500"
}
const _hoisted_10 = {
  key: 2,
  class: "absolute right-1 top-1 rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white"
}
const _hoisted_11 = { class: "block space-y-1 p-2 text-sm" }
const _hoisted_12 = { class: "block break-words font-semibold" }
const _hoisted_13 = { class: "block break-words text-gray-600" }
const _hoisted_14 = { class: "block font-medium text-indigo-700" }
const _hoisted_15 = { class: "block text-xs text-gray-600" }

import { ref } from 'vue';
import { replacementMoney, replacementProductTotal } from '@/api/remplacements';
import type { ReplacementProduct, ReplacementSelection } from '@/api/remplacements';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReplacementProductPicker',
  props: {
    products: {},
    selectedIds: {},
    selections: {},
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["choose"],
  setup(__props: any) {

const props = __props;

function total(product: ReplacementProduct) { return replacementProductTotal(product, props.selections.find(s => s.id_produit_remplacement === product.id_produit)); }
const failedImages = ref(new Set<string>());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("legend", { class: "mb-2 text-sm font-medium" }, "Produits proposés (10 max., 1 au choix)", -1)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Chargement des articles…"))
      : (!_ctx.products.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Aucun article disponible pour cette recherche. Essayez une autre référence. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id_produit,
                  type: "button",
                  "aria-label": `Choisir ${item.reference} · ${item.couleur}`,
                  "aria-pressed": _ctx.selectedIds.includes(item.id_produit),
                  disabled: _ctx.disabled,
                  class: _normalizeClass([
            'min-w-0 overflow-hidden rounded-lg border-2 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-wait',
            _ctx.selectedIds.includes(item.id_produit) ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 bg-white hover:border-indigo-300',
          ]),
                  onClick: ($event: any) => (_ctx.$emit('choose', item.id_produit))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    (item.image_url && !failedImages.value.has(item.image_url))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.image_url,
                          alt: `${item.reference} — ${item.couleur}`,
                          class: "h-full w-full object-contain",
                          loading: "lazy",
                          referrerpolicy: "no-referrer",
                          onError: ($event: any) => (failedImages.value.add(item.image_url))
                        }, null, 40, _hoisted_8))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "Photo indisponible")),
                    (_ctx.selectedIds.includes(item.id_produit))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "✓ Candidat"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.reference), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.couleur || 'Couleur non renseignée'), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(total(item).amount != null ? `${_unref(replacementMoney)(total(item).amount ?? 0)} HT au total` : 'Quantité à préciser'), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(total(item).description), 1)
                  ])
                ], 10, _hoisted_6))
              }), 128))
            ])
          ]))
  ]))
}
}

})